import { render, staticRenderFns } from "./add_input.vue?vue&type=template&id=2b1b4bae&lang=pug&"
import script from "./add_input.vue?vue&type=script&lang=js&"
export * from "./add_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports